import React from 'react';
import { Text, View } from 'react-native';
import { TranslationView } from '@levelapp/softfabric-ui';
import ProjectCalendar from '../../../../../Common/DTO/ProjectCalendar';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import HexagonView from './components/hexagon/HexagonView';
import {styles} from "./CalendarViewStyle";

interface CalendarViewProps {
    calendars: ProjectCalendar[];
}

export const CalendarView = ({calendars}: CalendarViewProps) => {

    return (
      <View style={styles.page}>
        <TranslationView style={styles.title}>calendar</TranslationView>
    
        <View style={styles.container}>
          {/* Boule en haut */}
          <View style={styles.circle} />
    
          {/* Ligne verticale */}
          <View style={styles.arrowView} />
    
          {/* Fl�che en bas */}
          <View style={styles.triangle} />
        </View>
    
        {calendars.map((calendar: ProjectCalendar, index: number) => {
          return (
            <View key={index} style={styles.row}>
              <HexagonView title={calendar.order.toString()} />
              <View style={styles.textView}>
                <Text style={styles.date}>{Helpers.getCorrectTranslation(calendar.calendarDate)}</Text>
                <Text style={styles.event}>{Helpers.getCorrectTranslation(calendar.calendarEvent)}</Text>
              </View>
            </View>
          )
        })}
      </View>
    );
}

export default CalendarView;